module.exports = __webpack_public_path__ + "static/15-f6574bd2d18223dd5adb63ed17ca213a.png";